<template>

    <form autocomplete="off" v-on:submit.prevent="submit" class="trax-form">

        <trax-ui-input type="text" :placeholder="lang.polaris.form.name" v-model="form.name" required="1">
        </trax-ui-input>

        <trax-ui-input type="text" :placeholder="lang.polaris.form.url" v-model="form.href" required="1">
        </trax-ui-input>

        <div class="trax-form-actions text-right">
            <button type="button" class="btn btn-default btn-link" data-dismiss="modal"> {{ lang.polaris.form.cancel }} </button>
            <button type="submit" class="btn btn-primary btn-round"> {{ lang.polaris.form.save }} </button>
        </div>
        
    </form>
    
</template>

<script>
    export default {

        props: {
            id: null,
            bus: null,
            endpoint: null,
        },
    
        data: function() {
            return {
                lang: lang,
                form: {},
            }
        },

        created: function() {
            this.bus.$on(this.id+'-edit-open', this.open);
        },
        
        methods: {

            open(data) {
                this.form = data ? data : {}
            },

            submit() {
                this.form.name = this.form.name.trim();
                this.form.href = this.form.href.trim();

                // Some local checks.
                var message = '';
                if (this.form.name == '') {
                    message = this.lang.polaris.form.error_name;
                } 

                if (this.form.href == '' || (
                    this.form.href.substring(0, 7) != 'http://'
                    && this.form.href.substring(0, 8) != 'https://'
                )) {
                    message = this.lang.polaris.form.error_url;
                } 

                // Error.
                if (message != '') {
                    this.bus.$emit(this.id+'-toastr-error', message);
                    return;
                }

                // OK, send it.
                this.bus.$emit(this.id+'-edit-create-or-update', this.form);
                this.bus.$emit(this.id+'-edit-close');
            }
        }
    }
</script>
